import { render, staticRenderFns } from "./onGetOperationButtonLabel-editor.vue?vue&type=template&id=ef17e87e&scoped=true&"
import script from "./onGetOperationButtonLabel-editor.vue?vue&type=script&lang=js&"
export * from "./onGetOperationButtonLabel-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef17e87e",
  null
  
)

export default component.exports